/**
 * Created with Mei Zhiwei on 2018-07-19 15:49:46.
 * Description: 状态
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: meizhiwei@meituan.com
 * @Last Modified time: 2018-07-19 15:52:03
 */
export const statuses = {
  0: '无效',
  1: '有效'
};



// WEBPACK FOOTER //
// ./src/config/statuses.js